import { maxLength } from "./validators";
import { fetchConceptByNameAndType } from "reducers/Concepts";
import { invalidCharacters } from "utils/common";

const CONCEPT_NAME_PATTERN = /^[ ,a-zA-Z0-9_+/\\\-().:«»~ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ&!@#$%^*=|]+$/;
export const CONCEPT_NAME_MAX_LENGTH = 500;
export const OPEN_CONCEPT_NAME_MAX_LENGTH = 225; // Concepts with conceptType === "HTML"


export function conceptNameAllowedChars(value){
	const invalidCharactersFunc = invalidCharacters(CONCEPT_NAME_PATTERN, value);
	const NAME_ERROR_MESSAGE = `${invalidCharactersFunc.join(" ")} ${invalidCharactersFunc.length > 1 ? 'are' : 'is'} not permitted in concept names`;
	return invalidCharactersFunc.length ? NAME_ERROR_MESSAGE : undefined;
}

export const conceptNameMaxLength = maxLength(CONCEPT_NAME_MAX_LENGTH);

export const openConceptNameMaxLength = maxLength(OPEN_CONCEPT_NAME_MAX_LENGTH);

// For use with async validation, creating new Concepts, or renaming them
export async function conceptNameExists(dispatch, libraryId, conceptName, conceptType){
	// Concept names are only required to be unique her conceptType.
	let concept = await dispatch(fetchConceptByNameAndType(libraryId, conceptName, conceptType));
	if(concept){
		throw {
			conceptName: "Concept Name already exists in the creative library.",
		};
	}
	return undefined;
}
